import { useEffect, useRef } from 'react';
import { Viewer2DHandle } from './Viewer2DHandle';

export const Viewer2DV2 = ({ viewer2DHandle }: { viewer2DHandle: Viewer2DHandle }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.appendChild(viewer2DHandle.canvasDom);
    }

    return () => {
      if (container) {
        container.removeChild(viewer2DHandle.canvasDom);
      }
    };
  }, [viewer2DHandle]);

  return <div ref={containerRef} style={{ display: 'contents' }} />;
};
